import { Broker } from '@axo/shared/data-access/types/broker';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send.ts';
import { payment_remark } from '@axo/shared/data-access/types';

export function triggerCreditCheck({ url: { service: baseURL }, token }: IAPI) {
  return ({
    personID,
    marketCountry,
    loanApplicationID,
    broker,
  }: {
    personID: string;
    marketCountry: string;
    loanApplicationID: string;
    broker: Broker;
  }): Promise<payment_remark.Trigger> =>
    send({
      baseURL,
      token,
      path: `/payment-remark/trigger`,
      method: 'POST',
      body: {
        PersonID: personID,
        LoanApplicationID: loanApplicationID,
        MarketCountry: marketCountry,
        CreatedFrom: 'ace',
        AllowCache: false,
        Broker: broker,
      },
    });
}
